import dev, { DevType } from "./environment.dev";
import prod, { ProdType } from "./environment.prod";

import staging, { StatingType } from "./environment.staging";

const env = process.env.REACT_APP_NODE_ENV;
type environment = StatingType | DevType | ProdType;
let APP_CONFIG: environment;

switch (env) {
  case "dev":
    APP_CONFIG = dev;
    break;

  case "staging":
    APP_CONFIG = staging;
    break;
  case "prod":
    APP_CONFIG = prod;
    break;

  default:
    APP_CONFIG = prod;
    break;
}
export default APP_CONFIG;
